import { render, staticRenderFns } from "./SentimentMarketHotDay.vue?vue&type=template&id=05c99ad6&scoped=true"
import script from "./SentimentMarketHotDay.vue?vue&type=script&lang=js"
export * from "./SentimentMarketHotDay.vue?vue&type=script&lang=js"
import style0 from "./SentimentMarketHotDay.vue?vue&type=style&index=0&id=05c99ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c99ad6",
  null
  
)

export default component.exports